'use client';

import { IconChevronDownFilled } from '@zillow/constellation-icons/react/filled/icon-chevron-down-filled';
import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { expandIconRecipe } from '../../styles/expand-icon.styles';
import { Icon } from '../icon';
import { ComboboxRootContext } from './context/combobox-root.context';
import { comboboxAdornmentRecipe } from './styles/combobox-adornment.styles';
import type { ComboboxAdornmentPropsInterface } from './types/combobox-adornment.types';

/**
 * @since 10.0.0
 */
export const ComboboxAdornment = forwardRef<HTMLSpanElement, ComboboxAdornmentPropsInterface>(
  (props: ComboboxAdornmentPropsInterface, forwardedRef) => {
    const { children, className, css: cssProp, ...rest } = props;
    const { combobox, size } = useContext(ComboboxRootContext);

    const styles = css(comboboxAdornmentRecipe.raw({ size }), cssProp);
    const iconStyles = css(expandIconRecipe.raw({ open: combobox.open }));

    const content = children || (
      <span className={cx('c11n', iconStyles)}>
        <Icon size="sm" render={<IconChevronDownFilled />} />
      </span>
    );

    return (
      <span
        ref={forwardedRef}
        data-c11n-component="Combobox.Adornment"
        data-c11n-version={__C11N_VERSION__}
        className={cx('c11n', styles, className)}
        {...rest}
      >
        {content}
      </span>
    );
  },
);

ComboboxAdornment.displayName = 'Combobox.Adornment';
